import { AppImageData } from '@components/appImage';

/**
 * @deprecated SmallCard устарел и будет удален в будущих версиях.
 */
export interface SmallCardProps {
  descriptionId?: string;
  description: string;
  /** Готовый signed URL. Legacy — для новых страниц используйте imageData. */
  imageSrc?: string;
  /** Данные AppImage (srcset + blur) из `getAppImageData`. Приоритетнее imageSrc. */
  imageData?: AppImageData;
  href?: string;
  countRow?: number;
  enumeration?: boolean;
  index?: number;
  type?: 'enumeration' | 'blurred';
  buttonContent?: string;
  buttonLink?: string;
  subDescription?: string;
  subDescriptionId?: string;
  smoothScroll?: boolean;
  alt?: string;
  isAnimateLinkIcon?: boolean;
  customClassNames?: {
    content?: string;
    img?: string;
    subDescription?: string;
    main?: string;
    contentContainer?: string;
  };
}

/**
 * @deprecated SmallCard устарел и будет удален в будущих версиях.
 */
export enum SmallCardType {
  ENUMERATION = 'enumeration',
  BLURRED = 'blurred',
}
